import {
    Link, TableCell, TableRow, TextField
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {formatDateUS} from "../../../../../helpers/utils";

const ForbesAumRow = ({session, getForbesAums, forbesAum}) => {
    const [totalAum, setTotalAum] = useState(forbesAum.total_aum);
    const [minimumAccountSize, setMinimumAccountSize] = useState(forbesAum.minimum_account_size);

    const removeForbesAum = (id) => {
        axios.delete(
            `/v1/admin/forbes_aums/${id}`,
            {
                headers: {
                    'X-Admin-User-Email': session.email,
                    'X-Admin-User-Token': session.token
                }
            }
        ).then((response) => {
            getForbesAums()
        });
    }

    const updateForbesAum = (data) => {
        axios.put(
            `/v1/admin/forbes_aums/${forbesAum.id}`,
            {
                forbes_aum: {...forbesAum, ...data, automatic: false},
            }, {
                headers: {
                    'X-Admin-User-Email': session.email,
                    'X-Admin-User-Token': session.token
                }
            }
        ).then((response) => {
            const {forbes_aums} = response.data;
        });
    }

    return (
        <TableRow hover key={forbesAum.id}>
            <TableCell>{forbesAum.year}</TableCell>
            <TableCell>
                <TextField
                    label="AUM"
                    variant="outlined"
                    name='total_aum'
                    type='number'
                    value={totalAum}
                    onChange={(event) => setTotalAum(event.target.value)}
                    onBlur={(event) => updateForbesAum({total_aum: event.target.value})}
                />
            </TableCell>
            <TableCell>
                <TextField
                    label="Minimum Account Size"
                    variant="outlined"
                    name='minimum_account_size'
                    type='number'
                    value={minimumAccountSize}
                    onChange={(event) => setMinimumAccountSize(event.target.value)}
                    onBlur={(event) => updateForbesAum({minimum_account_size: event.target.value})}
                />
            </TableCell>
            <TableCell>{formatDateUS(forbesAum.created_at)}</TableCell>
            <TableCell>{forbesAum.automatic ? 'Automatic' : 'Manual'}</TableCell>
            <TableCell>
                <Link to='' onClick={(event) => removeForbesAum(forbesAum.id)}>Remove</Link>
            </TableCell>
        </TableRow>
    )
}

export default ForbesAumRow;